export { Modal, ModalOverlay } from '@chakra-ui/react';
export type {
  ModalBodyProps,
  ModalCloseButtonProps,
  ModalContentProps,
  ModalFooterProps,
  ModalHeaderProps,
  ModalOverlayProps,
  ModalProps
} from '@chakra-ui/react';
export { ModalBody } from './modal-body';
export { ModalCloseButton } from './modal-close-button';
export { ModalCloseLink } from './modal-close-link';
export { ModalContent } from './modal-content';
export { ModalFooter } from './modal-footer';
export { ModalHeader } from './modal-header';
export { ModalHeading } from './modal-heading';
